import { render, staticRenderFns } from "./DataLoggerAccess.vue?vue&type=template&id=7e64cd3b&scoped=true&"
import script from "./DataLoggerAccess.vue?vue&type=script&lang=js&"
export * from "./DataLoggerAccess.vue?vue&type=script&lang=js&"
import style0 from "./DataLoggerAccess.vue?vue&type=style&index=0&id=7e64cd3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e64cd3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VSelect,VSwitch})
